module.exports = __webpack_public_path__ + "static/media/notification-dark.659ee229.svg";